<template>
  <div class="page-user-select">
    <c-left-side-bar :step="2" />
    <n-loader :loading="$var('load')" />
    <div class="mid-container">
      <div class="mid-side">
        <c-mid-head back-route="kln-info" h1="Список сотрудников" />
        <n-form @submit="submit">
          <n-items>
            <div class="input-place">
              <n-button type="submit"><img :src="searchIcon" alt=""></n-button>
              <n-input v-model="search" placeholder="Поиск табельному номеру или ФИО" />
            </div>
          </n-items>
        </n-form>
        <div class="user-count">
          Количество пользователей: {{ filteredUsers.length }}
        </div>
        <ul class="users-list">
          <li v-for="item in filteredUsers" :key="item.id" class="user-row">
            <label
              v-if="item.id !== $app.auth.user().id" class="user-part"
              :class="{'green': item.resultCount <= 5 && item.resultCount >= 2, 'red': item.resultCount < 2}">
              <input v-model="user" type="radio" :name="item.id" :value="item">
              <img :src="altAvatar" alt="">
              <span class="user-part-info">
                <span>{{ item.fullName }}</span>
                <div class="user-part-info-bottom">
                  <p>Должность: {{ accessesTypes[item.accesses?.[0]?.title] || 'Работник' }}</p>
                </div>
                <div class="user-part-info-bottom">
                  <p>Табельный номер: {{ item.personnelNumber }}</p>
                  <p>Пройдено КЛН: {{ item.resultCount }}/5</p>
                </div>
              </span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="new-right-side right-container">
      <div class="right-side">
        <div class="text-container">
          <div class="branch-selector">
            <div class="title">{{ $app.auth.user().branch?.title }}</div>
          </div>
          <p>
            Проходить контрольный лист наблюдателя может только один сотрудник из одного устройства.
            Выберите из списка или найдите сотрудника
            в поиске по табельному номеру
          </p>
        </div>
        <div>
          <n-button v-if="type === 'kln'" class="btn-green" :disabled="!isBtnDisabled" @click="next('education')">Обучение (без сотрудника)</n-button>
          <n-button v-if="type === 'kln'" class="btn-green" :disabled="isBtnDisabled" @click="next('education')">Пройти обучение</n-button>
          <n-button v-if="type === 'timer'" class="btn-green" :disabled="isBtnDisabled" @click="timer('kln')">Начать оценку</n-button>
          <n-button v-if="type === 'kln'" class="btn-green" :disabled="isBtnDisabled" @click="next('kln')">Начать КЛН</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchIcon from 'assets/searchIcon/search-btn-icon.png'
import altAvatar from 'assets/altAvatar/alt-avatar.png'

export default {
  name: 'PageUserSelect',
  data() {
    return {
      altAvatar,
      searchIcon,
      users: [],
      user: [],
      type: '',
      isBtnDisabled: true,
      search: '',
      accessesTypes: {
        plotManager: 'Менеджер участка',
        trainingManager: 'Менеджер по обучению',
        instructor: 'Инструктор',
        superAdmin: 'Топ менеджер',
        director: 'Директор филиала',
        deputyDirector: 'Первый Зам. Директор',
        departmentLeader: 'Зам. Директор Люди',
        serviceLeader: 'Зам. Директор Сервис/Производство',
        shiftManager: 'Менеджер смены',
        HRSpecialist: 'Специалист по персоналу',
        scheduleManager: 'Менеджер расписания',
        technician: 'Техник',
      },
    }
  },
  computed: {
    filteredUsers() {
      const regex = new RegExp(this.search, 'i')
      if (this.search.length > 0) {
        return $n.filter(this.users, (item) => {
          const result = item.personnelNumber?.match(regex)
          return result?.length > 0 || item.fullName?.match(regex)
        })
      } else {
        return this.users
      }
    },
  },
  watch: {
    user() {
      this.isBtnDisabled = false
    },
  },
  created() {
    this.submit()
    this.type = this.$route.query.type
  },
  methods: {
    submit() {
      this.$var('load', true)
      console.log(this.$route.query.type)
      if (this.$route.query.type === 'kln') {
        $api.users.getKln().all().with('resultCount').with('accesses').filter({ branchId: $app.auth.user().branch?.id, })
          .then((response) => {
            this.users = response.data.content
          }).finally(() => {
            this.$var('load', false)
          })
      }
      if (this.$route.query.type === 'timer') {
        $api.users.getTimer().all().with('resultCount').with('accesses').filter({ branchId: $app.auth.user().branch?.id, })
          .then((response) => {
            this.users = response.data.content
          }).finally(() => {
            this.$var('load', false)
          })
      }
    },
    timer(type) {
      this.$router.push({ name: 'kln-timer-categories', query: { userId: this.user?.id, resultType: type, access: this.user.accesses?.[0]?.title, }, })
    },
    next(type) {
      this.$router.push({ name: 'kln-categories', query: { userId: this.user?.id, resultType: type, access: this.user.accesses?.[0]?.title, }, })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-user-select {
  display: flex;
  height: 100vh;
  overflow: hidden;

  .branch-selector {
    background-color: #e8e8e8;
    padding: 8px;
    height: 40px;
    border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .title {
      font-size: 16px;
    }
    .icon-place {
      margin-right: 10px;
      transform: rotate(90deg);
      width: 8px;
      height: 14px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

  }
   .user-count {
     padding: 5px;
     font-size: 14px;
     margin-top: 20px;
   }

  .mid-container {
    padding: 40px 20px 0 20px;
    width: 100%;

    .mid-side {

      .users-list {
        list-style: none;
        padding: 0 10px 0 0;
        position: relative;
        overflow: auto;
        height: calc(100vh - 260px);

        .user-row {
          display: flex;
          &::before {
            content: '';
            position: absolute;
            width: 90%;
            height: 1px;
            background-color: #E9E9EC;
            right: 20px;
            bottom: -9px;
          }

          .user-part {
            display: flex;
            align-items: center;
            padding: 5px;
            border-radius: 12px;
            margin-bottom: 5px;
            &.red {
              background-color: rgba(255, 0, 0, 0.4);
            }
            &.green {
              background-color: rgba(10, 234, 10, 0.42);
            }
            input {
              width: 20px;
              height: 20px;
              margin-right: 14px;
            }

            img {
              width: 44px;
              height: 44px;
            }

            .user-part-info {
              padding-left: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              h3 {
                padding: 3px 0 0 0;
                font-size: 17px;
                color: #292929;
                margin: 0;
              }
              .user-part-info-bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 435px;
                p {
                  padding: 3px 0 0 0;
                  margin: 0;
                  font-size: 14px;
                  color: #6D6F7B;
                }
              }
            }
          }
        }
      }

      h1 {
        text-align: left;
        vertical-align: center;
        font-size: 17px;
        font-weight: bold;
        color: #000000;
      }

      .tabs {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &::v-deep .n-tabs {
        position: relative;
        color: #969FA8;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        padding: 0;

        & .active {
          color: #292929;
          border-bottom: 2px solid #292929;
        }
      }

      .input-place {
        width: 530px;
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #F4F4F4;
        border-radius: 10px;
        position: relative;

        &::v-deep .n-input {
          width: 510px;

          .n-content {
            border: none;
            background-color: #F4F4F4;
            border-radius: 10px;
          }
        }

        &::v-deep .n-button {
          border: none;
          background-color: inherit;

          img {
            position: absolute;
            top: 14px;
            left: 15px;
            bottom: -10px;
            width: 16px;
            height: 16px;
          }
        }

        &::v-deep .n-button:active {
          box-shadow: none;
          border-color: inherit;
          background-color: transparent !important;
          outline: none !important;
        }
      }
    }
  }

  .new-right-side {
    overflow: auto;
  }
  .right-container {
    .right-side {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h2 {
        font-weight: bold;
        font-size: 32px;
      }

      .text-container {
        p {
          position: relative;
          max-width: 400px;
          font-size: 17px;
          color: #292929;
          padding-left: 12px;

          &.secondary {
            color: #6D6F7B;
            padding: 0;

            &::before {
              display: none;
            }
          }

          &::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #264F36;
            position: absolute;
            left: 0;
            top: 8px;
          }
        }
      }

      .btn-green {
        font-size: 17px;
        background-color: #264F36;
        color: #ffffff;
        max-width: 390px;
        left: 20px;
        width: 100%;
        font-weight: bold;
        margin-bottom: 20px;
      }

      &::v-deep .n-button:hover {
        background-color: #3C7853;
      }

      &::v-deep .n-button:active {
        background-color: #0F4122;
      }
    }
  }
}
</style>
